export const contentElementAnimations = async (err) => {
  if (err) {
    console.error(err);
  }

  /*
  /* div Elements Animations on scroll
  */
  reveal();
  function reveal() {
    var reveals = document.querySelectorAll('.reveal');

    for (var i = 0; i < reveals.length; i++) {
      var windowHeight = window.innerHeight;
      var elementTop = reveals[i].getBoundingClientRect().top;
      var elementVisible = 10;

      var delay = 100;
      if (reveals[i].classList.contains('delay-1000')) {
        delay = 1000;
      }
      if (reveals[i].classList.contains('delay-500')) {
        delay = 500;
      }
      if (reveals[i].classList.contains('delay-200')) {
        delay = 200;
      }

      if (elementTop < windowHeight - elementVisible) {
        let that = reveals[i];
        setTimeout(() => {
          that.classList.add('active');
        }, delay);
      } /*  else {
        reveals[i].classList.remove("active");
      } */
    }
  }
  window.addEventListener('scroll', reveal);
};

import.meta.webpackHot?.accept(contentElementAnimations);
